type ConstValues<T extends Record<string, string>> = T[keyof T];

export const AUTO_DELIVERY_STATUS_TYPES = {
    NONE: 'NONE',
    ACTIVE: 'ACTIVE',
    ON_HOLD: 'ON_HOLD',
    INACTIVE: 'INACTIVE',
    PAYMENT_PENDING: 'PAYMENT_PENDING',
} as const;

export type AutoDeliveryStatus = ConstValues<typeof AUTO_DELIVERY_STATUS_TYPES>;

export const AUTO_DELIVERY_DCX_STATUS_TYPES = {
    NONE: 'NONE',
    ACTIVE: 'ACTIVE',
    ON_HOLD: 'ON_HOLD',
    FAILED: 'FAILED',
    CANCELED: 'CANCELED',
} as const;

export type AutoDeliveryDcxStatus = ConstValues<typeof AUTO_DELIVERY_DCX_STATUS_TYPES>;

export const AUTO_DELIVERY_FREQUENCY_TYPES = {
    DAILY: 'DAILY',
    WEEKLY: 'WEEKLY',
    BIWEEKLY: 'BIWEEKLY',
    MONTHLY: 'MONTHLY',
    BIMONTHLY: 'BIMONTHLY',
} as const;

export type AutoDeliveryFrequency = ConstValues<typeof AUTO_DELIVERY_FREQUENCY_TYPES>;

export const AUTO_DELIVERY_ORDER_STATUS_TYPES = {
    EXPECTED: 'EXPECTED',
    PROCESSED: 'PROCESSED',
    ON_ITS_WAY: 'ON_ITS_WAY',
} as const;

export type AutoDeliveryOrderStatus = ConstValues<typeof AUTO_DELIVERY_ORDER_STATUS_TYPES>;

export const AUTO_DELIVERY_DCX_ORDER_STATUS_TYPES = {
    PROCESSED: 'PROCESSED',
    ON_ITS_WAY: 'ON_ITS_WAY',
    COMPLETED: 'COMPLETED',
    EXPECTED: 'EXPECTED',
} as const;

export type AutoDeliveryDcxOrderStatus = ConstValues<typeof AUTO_DELIVERY_DCX_ORDER_STATUS_TYPES>;

export const AUTO_DELIVERY_UPDATE_REASON_STATUS_TYPES = {
    PAY_FAIL: 'PAY_FAIL',
    OUT_OF_STOCK: 'OUT_OF_STOCK',
    DELIVERY_FAIL: 'DELIVERY_FAIL',
} as const;

export type AutoDeliveryUpdateReasonStatus = ConstValues<typeof AUTO_DELIVERY_UPDATE_REASON_STATUS_TYPES>;

export const AUTO_DELIVERY_DCX_UPDATE_REASON_STATUS_TYPES = {
    ERR_AD_STOCK_01: 'ERR_AD_STOCK_01',
    ERR_AD_LSP_01: 'ERR_AD_LSP_01',
    ERR_AD_LSP_02: 'ERR_AD_LSP_02',
    AD_ERROR_01: 'AD_ERROR_01',
    AD_ERROR_02: 'AD_ERROR_02',
    ERR_AD_STOCK_02: 'ERR_AD_STOCK_02',
    AD_HOLD_02: 'AD_HOLD_02',
    AD_HOLD_05: 'AD_HOLD_05',
    AD_HOLD_06: 'AD_HOLD_06',
} as const;

export type AutoDeliveryDcxUpdateReasonKnownStatus = ConstValues<typeof AUTO_DELIVERY_DCX_UPDATE_REASON_STATUS_TYPES>;
export type AutoDeliveryDcxUpdateReasonStatus = AutoDeliveryDcxUpdateReasonKnownStatus | string;

export const validateAutoDeliveryOrderStatus = (status?: string | null): status is AutoDeliveryOrderStatus => {
    if (!status) return false;

    return status in AUTO_DELIVERY_ORDER_STATUS_TYPES;
};

export const validateAutoDeliveryDcxOrderStatus = (status?: string | null): status is AutoDeliveryDcxOrderStatus => {
    if (!status) return false;

    return status in AUTO_DELIVERY_DCX_ORDER_STATUS_TYPES;
};

export const isAutoDeliveryDcxOrderExpected = (status?: string | null): boolean =>
    status === AUTO_DELIVERY_DCX_ORDER_STATUS_TYPES.EXPECTED;
